package com.exura.features.demosets.domain.model

import kotlinx.serialization.Serializable
import kotlin.js.JsName

// Publish Demo Set
@Serializable
@JsName("PublishDemoSetRequest")
data class PublishDemoSetRequest(
    @JsName("targetDemoId")
    val targetDemoId: String,

    @JsName("isPrivate")
    val isPrivate: Boolean,

    @JsName("planDefinitionId")
    val planDefinitionId: String
)

@Serializable
@JsName("PublishDemoSetResponse")
data class PublishDemoSetResponse(
    @JsName("success")
    val success: Boolean,

    @JsName("newPlanDefinitionId")
    val newPlanDefinitionId: String? = null,

    @JsName("message")
    val message: String? = null
)

@Serializable
data class ListDemoSetsResponse(
    @JsName("success")
    val success: Boolean,

    @JsName("demoSets")
    val demoSets: Array<DemoSet> = emptyArray(),

    @JsName("message")
    val message: String? = null
)

// Import Demo Set
@Serializable
@JsName("ImportPublicDemoSetRequest")
data class ImportPublicDemoSetRequest(
    @JsName("demoSetId")
    val demoSetId: String,
)

@Serializable
@JsName("ImportPrivateDemoSetRequest")
data class ImportPrivateDemoSetRequest(
    @JsName("accessCode")
    val accessCode: String
)

@Serializable
@JsName("ImportDemoSetResponse")
data class ImportDemoSetResponse(
    @JsName("success")
    val success: Boolean,

    @JsName("importedPlanIds")
    val importedPlanIds: Array<String> = emptyArray(),

    @JsName("message")
    val message: String? = null
)
